module.exports = __webpack_public_path__ + "static/media/spirit woman.cb4f3c92.png";